import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { NgGlyph } from "@ng-icons/core";
import { AppCardComponent } from "../../../Common/Components/Card/CardComponent";
import { AppButtonComponent } from "../../../Common/Components/Button/ButtonComponent";

@Component({
  standalone: true,
  selector: "app-forbidden",
  imports: [RouterLink, NgGlyph, AppCardComponent, AppButtonComponent],
  templateUrl: "./ForbiddenPage.html",
  styleUrl: "./ForbiddenPage.scss",
})
export class ForbiddenPage {}
